import { APIProvider } from '@vis.gl/react-google-maps'
import type { ReactNode } from 'react'
import invariant from 'tiny-invariant'

export interface GoogleMapsProviderProps {
  children: ReactNode
}

export const GoogleMapsProvider = ({ children }: GoogleMapsProviderProps) => {
  invariant(typeof process.env.NEXT_PUBLIC_GOOGLE_MAPS_API_KEY === 'string', 'Google maps api key must be set!')

  return <APIProvider apiKey={process.env.NEXT_PUBLIC_GOOGLE_MAPS_API_KEY}>{children}</APIProvider>
}
